module.exports = __webpack_public_path__ + "img/red_008.4b574d39.png";